import Form from './Form.client'

export default Form
